import React, {Component} from "react"
import PropTypes from "prop-types"
import {Label2} from "@irati/ui/src/Labels"
import AngleDown from "react-icons/lib/fa/angle-down"
import AngleUp from "react-icons/lib/fa/angle-up"
import {getResolvedMessage, injectIntl} from "@irati/utils/lang"

import "./Expand.css"

class Expand extends Component {
  static propTypes = {
    above: PropTypes.bool,
    children: PropTypes.node,
    stickyComponent: PropTypes.func,
    uppercase: PropTypes.bool,
    hideText: PropTypes.string,
    showText: PropTypes.string
  };

  static defaultProps = {
    above: false,
    children: null,
    stickyComponent: () => {},
    uppercase: true,
    showText: "perks.components.expand.showText",
    hideText: "perks.components.expand.hideText"
  };

  constructor() {
    super()
    this.state = {
      isOpen: false
    }
  }

  handleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  };

  render() {
    const {above, children, stickyComponent, uppercase, hideText, showText} = this.props
    const {isOpen} = this.state
    return (
      <div>
        {isOpen && above && children}
        {stickyComponent && <this.props.stickyComponent />}
        <Label2
          bold
          uppercase={uppercase}
          style={{cursor: "pointer"}}
          onClick={this.handleOpen}>
          {isOpen ? hideText && getResolvedMessage(this, "hideText") : showText && getResolvedMessage(this, "showText")}
          {" "}
          {isOpen ? <AngleUp className="pull-right" /> : <AngleDown className="pull-right" />}
        </Label2>
        {isOpen && !above && children}
      </div>
    )
  }
}

export default injectIntl(Expand)
